import * as React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import Section from './shared/Section';
import C from '../colors';
import TextBlock from '../components/swace/text-block';
import { DynamicLink } from '../components/shared/components';
import Text from './shared/Text';
import s from './Footer.module.scss';

interface Props {}

class Footer extends React.Component<Props> {
  render() {
    return (
      <StaticQuery
        query={QUERY}
        render={data => {
          const menus = data.allWordpressWpApiMenusMenusItems.edges.map(
            e => e.node
          );
          const footerMenu = menus.find(m => m.slug === 'footer-menu');
          const policiesMenu = menus.find(m => m.slug === 'policies');
          const contactMenu = menus.find(m => m.slug === 'contact-menu');

          const { options } = data.wordpressAcfOptions;
          const logotype = options.logotype_footer;

          const { url: baseUrl } = data.wordpressSiteMetadata;

          return (
            <div className={s.wrapper}>
              <Section backgroundColor={C.BLACK}>
                <div className="row">
                  <div className="col-12 col-sm-6">
                    {logotype && (
                      <div className={s.logotype}>
                        <Img
                          style={{ width: '280px' }}
                          fluid={logotype.localFile.childImageSharp.fluid}
                        />
                      </div>
                    )}
                    <div className={s.email}>{options.email}</div>
                    <Text pSmall light>
                      <TextBlock text={options.address} />
                    </Text>
                  </div>
                  <div className={`col-sm-6 ${s.menus}`}>
                    <div className="row">
                      <div className="col-12 col-sm-6">
                        <div className={s.menuTitle}>
                          <Text label light>
                            {options.discover_menu_title}{' '}
                          </Text>
                        </div>
                        <div className={s.menu}>
                          {footerMenu.items.map((item, i) => (
                            <DynamicLink
                              key={i}
                              to={item.url.replace(baseUrl, '')}
                            >
                              {item.title}
                            </DynamicLink>
                          ))}
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="row">
                          <div className="col-6 col-md-12">
                            <div className={s.menuTitle}>
                              <Text label light>
                                {policiesMenu.name}
                              </Text>
                            </div>
                            <div className={s.menu}>
                              {policiesMenu &&
                                policiesMenu.items.map((item, i) => (
                                  <DynamicLink
                                    key={i}
                                    to={item.url.replace(baseUrl, '')}
                                  >
                                    {item.title}
                                  </DynamicLink>
                                ))}
                            </div>
                          </div>
                          <div className="col-6 col-md-12">
                            <div className={s.menuTitle}>
                              <Text label light>
                                {options.contact_menu_title}
                              </Text>
                            </div>
                            <div className={s.menu}>
                              {contactMenu.items.map((item, i) => (
                                <DynamicLink
                                  key={i}
                                  to={item.url.replace(baseUrl, '')}
                                >
                                  {item.title}
                                </DynamicLink>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Section>
            </div>
          );
        }}
      />
    );
  }
}

const QUERY = graphql`
  query {
    wordpressSiteMetadata {
      url
    }
    allWordpressWpApiMenusMenusItems {
      edges {
        node {
          name
          slug
          items {
            order
            title
            url
          }
        }
      }
    }
    wordpressAcfOptions {
      options {
        follow_menu_title
        contact_menu_title
        discover_menu_title
        address
        email
        logotype_footer {
          localFile {
            childImageSharp {
              fluid(maxWidth: 800, quality: 90) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
        }
      }
    }
  }
`;

export default Footer;
